import React from "react";
import SelectPaymentMode from "../../../../../views/pages/manage/unAssigned/collectPayment/selectPaymentMode/SelectPaymentMode";
import ViewFullBreakup from "../../../../../views/pages/manage/unAssigned/collectPayment/selectPaymentMode/viewFullBreakup/ViewFullBreakup";
import CollectedPayments from "../../../../../views/pages/manage/unAssigned/collectPayment/selectPaymentMode/collectedPaymentDetails/CollectedPayments";
import { useGetRectifyRefundPaymentModeContext } from "./context";
import PaymentModeTopStrip from "../../../../../views/pages/manage/unAssigned/collectPayment/alertMessages/PaymentModeTopStrip";
import { useZeroPaidAmountCase } from "../../../../../views/pages/manage/unAssigned/collectPayment/context/customHook";
import { useWizard } from "../../../../../components/wizard/WizardContext";

const SelectPaymentModeWrapper = ({ module }) => {

    const {values} = useWizard();

    const {roleId, newPaymentModesRawObject} = values?.utils;

    const {
        setModifyPaymentModeData,
        modifyPaymentModeData,
        setCurrentPaymentMode,
        currentPaymentMode,
        setPaymentModeForm,
        setBankDropdown,
        studentBasicDetails,
        // roleId,
        setBankMasterId,
        balanceMode,
        setPaymentModeIdLimitList,
        bankDropdown,
        paymentModeIdLimitList,
        paymentModeFormHandler,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceMode,
        setBalanceAmount,
        loader,
        setloader,
        setCollectPayment,
        balanceAmount,
        collectPayment,
        isOnlineModeEnabled,
        selectedCharges,
        collectVoucherList,
        vouchersDialogOpen,
        setVouchersDialogOpen,
        availablePosList,
        state,
        setState,
        forCentralizedAdmission,
        validatePaymentMode,
        disableAmountField,
        noAmountChange
    } = useGetRectifyRefundPaymentModeContext();

    // const getPaymentModeAndVouchersReqObj = () => {
    //     const { psid, bu, businessArea, opportunityOwnerId, rollNumber } = studentBasicDetails;
    //     return {
    //         psid,
    //         applicationId: null,
    //         roleId,
    //         businessArea: bu ?? businessArea,
    //         opportunityOwnerId,
    //         examRollNumber: rollNumber,
    //         processType: "Exam Payment Collection",
    //     }
    // }

    const getPaymentModesAndVouchers = () => newPaymentModesRawObject;


    const contextValue = {
        state,
        setState,
        setModifyPaymentModeData,
        modifyPaymentModeData,
        setCurrentPaymentMode,
        setBankDropdown,
        setPaymentModeForm,
        studentBasicDetails,
        roleId,
        setBankMasterId,
        balanceMode,
        setPaymentModeIdLimitList,
        bankDropdown,
        paymentModeIdLimitList,
        paymentModeFormHandler,
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceMode,
        setBalanceAmount,
        loader,
        setloader,
        setCollectPayment,
        balanceAmount,
        collectPayment,
        isOnlineModeEnabled,
        selectedCharges,
        collectVoucherList,
        vouchersDialogOpen,
        setVouchersDialogOpen,
        availablePosList,
        forCentralizedAdmission,
        validatePaymentMode,
        // getPaymentModeAndVouchersReqObj,
        getPaymentModesAndVouchers,
        // getFilteredPaymentModes
        disableAmountField,
        noAmountChange
    };

    useZeroPaidAmountCase(
        selectedCharges,
        balanceAmount,
        setCollectPayment,
        collectPayment
    );

    return (
        <>
            <PaymentModeTopStrip module={module} />
            <div className="d-flex mt-2" style={{ columnGap: "10px" }}>
                <SelectPaymentMode contextValue={contextValue} module={module}/>
                <div style={{ width: "33%" }}>
                    <ViewFullBreakup module={module} title="Old Receipt Amount"/>
                    <CollectedPayments contextValue={contextValue} module={module} title="New Receipt" showNextButton={false}/>
                </div>
            </div>
        </>
    );
};

export default SelectPaymentModeWrapper;
